export default __webpack_public_path__ + "static/media/R2.7022133f.PNG";